export type PickAssignableKeys<T, U> = {
	[K in keyof T]: T[K] extends U ? K : never;
}[keyof T];

export function assertObjectHasKey<T extends object>(
	obj: T,
	key: string | number | symbol,
): asserts key is keyof T {
	if (!(key in obj)) {
		throw new Error(
			`Key "${key.toString()}" is not a valid key of the given object.`,
		);
	}
}

export const EMPTY_PROMISE_FUNCTION = (resolve: VoidFunction) => {
	resolve();
};

export function getNumberEnumOptions<TEnum>(
	enumObj: Record<string, TEnum>,
): Exclude<TEnum, string>[] {
	return Object.values(enumObj).filter(
		(
			v,
		): v is Record<string, Exclude<TEnum, string>>[keyof Record<
			string,
			TEnum
		>] => typeof v === "number",
	);
}
